import styled from 'styled-components';
import { Modal } from 'antd';
import { mediaMax } from 'themes/helpers';

export const Container = styled.div`
  max-width: ${({ width }) => (width && width) || '1240px'};
  padding: 0 30px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

export const StyledFooter = styled.footer`
  font-family: 'Lato', sans-serif;
  padding: 30px 0;
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .col {
      display: flex;
      align-items: center;
    }
  }
  button {
    cursor: pointer;
  }
  hr {
    margin: 15px 0 25px;
    border: none;
    border-top: solid 1px rgba(255,255,255,.3);
  }
  .aw-logo {
    width: 54px;
    height: auto;
    margin-right: 10px;
  }
  .eu {
    font-size: 3.6em;
    font-weight: 300;
    text-transform: uppercase;
    margin-right: 15px;
  }
  .info {
    font-size: 1.6em;
  }
  .hashtag {
    font-size: 1.8em;
    margin-right: 5px;
  }
  .icon {
    padding: 10px 15px;
  }
  .backtotop {
    margin-left: 5px;
    font-size: 1.6em;
    font-weight: bold;
    letter-spacing: .75px;
  }
  .links {
    font-size: 1.4em;
    .separator {
      display: inline-block;
      padding: 0 7px;
      font-weight: bold;
    }
    a {
      font-weight: bold;
      color: #FFF;
    }
    p {
      font-weight: normal;
    }
  }
  .copyright {
    font-size: 1.4em;
    font-weight: bold;
  }
  ${mediaMax.phoneL`
    .row {
      .col {
        flex-wrap: wrap;
      }
    }
  `};
`;

export const WeChat = styled(Modal)`
  .ant-modal-body {
    padding: 0!important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Footer/styles.js